/**
 * Whether a verify-code screen should navigate on because another tab
 * completed 2FA for the SAME session (the verified token arrives via the
 * session store's cross-tab update). A synced session belonging to a different user is left
 * alone: auto-leaving would silently complete 2FA across users on a shared
 * computer, regressing the owner guard (resolve-return-url.ts). A failure in
 * another tab writes no token, so it can never trigger this.
 */
export const shouldLeaveVerifyScreenOnSync = (
  hasTwoFactorToken: boolean,
  subAtMount: string | undefined,
  currentSub: string | undefined,
): boolean =>
  hasTwoFactorToken &&
  !!currentSub &&
  !!subAtMount &&
  currentSub === subAtMount;
